// We are using a JavaScript config file instead of the jsconfig.json or the .env file. JavaScript allows us to write code and comments during config.
const appConfig = {
  serverBaseUrl: process.env.REACT_APP_ENV === "DEV" ? 'https://api-dev.yamaha-lms.hummingwave.com' : process.env.REACT_APP_ENV === "PROD" ? 'https://78q8t6p7s4.execute-api.ap-southeast-1.amazonaws.com/v1' : 'https://zgh4ccfjs3.execute-api.ap-southeast-1.amazonaws.com/v1'
}
console.log("env",process.env.REACT_APP_ENV);
export default appConfig;